let router = [
    {
        path: '/marketing/landingpage',
        name: 'landingpage',
        component: () => import('@/views/marketing/landingpage/index.vue'),
        meta: {keepAlive: true, parentPath: 'marketing'},
    },
    {
        path: '/marketing/landingpage/edit',
        name: 'landingpageedit',
        component: () => import('@/views/marketing/landingpage/edit.vue'),
        meta: {keepAlive: true, parentPath: 'marketing'},
    },
    {
        path: '/marketing/order',
        name: 'marketingorder',
        component: () => import('@/views/marketing/order/index.vue'),
        meta: {keepAlive: true, parentPath: 'marketing'},
    },
    {
        path: '/marketing/digitalproduct',
        name: 'digitalproduct',
        component: () => import('@/views/marketing/digitalproduct/index.vue'),
        meta: {keepAlive: true, parentPath: 'marketing'},
    },
    {
        path: '/marketing/digitalproduct/edit',
        name: 'digitalproductedit',
        component: () => import('@/views/marketing/digitalproduct/edit.vue'),
        meta: {keepAlive: true, parentPath: 'marketing'},
    },
    {
        path: '/marketing/digitalorder',
        name: 'digitalorder',
        component: () => import('@/views/marketing/digitalorder/index.vue'),
        meta: {keepAlive: true, parentPath: 'marketing'},
    }
    
    
]
export default router


// WEBPACK FOOTER //
// ./src/router/marketing.js